import React from 'react';
import { Route, Routes } from "react-router-dom";
import { observer } from "mobx-react-lite";
import Login from './components/Auth/Login';
import CustomGoogleSignIn from './components/Auth/CustomGoogleSignIn';
import PersistLogin from './components/Auth/PersistLogin';
import RequireAuth from './components/Auth/RequireAuth';
import NotFound from "./components/NotFound";
import Layout from './components/Common/Layout';
import MainLayout from './components/Common/MainLayout';
import { ImpersonationHandler, ImpersonationEnded } from './components/Impersonation';

function App() {
    return (
        <Routes>
            {}
            <Route path="/impersonate" element={<ImpersonationHandler />} />
            <Route path="/impersonation-ended" element={<ImpersonationEnded />} />

            <Route path="/" element={<Layout />}>
                <Route index element={<Login />} />
                <Route path="CustomGoogleSignIn" element={<CustomGoogleSignIn />} />
                <Route element={<PersistLogin />}>
                    <Route element={<RequireAuth />}>
                        <Route path="*" element={<MainLayout />} />
                    </Route>
                </Route>
            </Route>
        </Routes>
    );
}

export default observer(App);
